<template>
  <div class="floating-card" :class="feelingClass">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FloatingCard',
  props: {
    feeling: {
      type: String,
      validator: (prop) => [
        'positive',
        'highlighted',
        'pending',
        'muted',
        'negative',
      ].includes(prop),
    },
  },
  computed: {
    feelingClass() {
      return this.feeling ? `floating-card--${this.feeling}` : false;
    },
  },
};
</script>

<style scoped>
.floating-card {
  max-width: 36em;
  padding: var(--unit-extra-large);
  border-radius: var(--token-border-radius);
  background-color: var(--token-color-fill-white);
  box-shadow: var(--token-shadow);
  transition: box-shadow 0.3s ease-in-out;
}

.floating-card--positive {
  box-shadow: var(--token-shadow-positive);
}

.floating-card--highlighted {
  box-shadow: var(--token-shadow-highlighted);
}

.floating-card--pending {
  box-shadow: var(--token-shadow-pending);
}

.floating-card--muted {
  color: var(--token-color-body-muted);
  box-shadow: var(--token-shadow-muted);
}

.floating-card--negative {
  box-shadow: var(--token-shadow-negative);
}
</style>
